import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby'

function RedirectWithParams({ pageContext }) {
  const queryString = typeof window === 'undefined' ? '' : window?.location?.search
  const toPathWithParam = pageContext.toPath + queryString
  useEffect(() => {
    navigate(toPathWithParam)
  }, [])
  return null
}

RedirectWithParams.propTypes = {
  pageContext: PropTypes.object.isRequired
}

export default RedirectWithParams
